import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, ListItem, ListItemText, Skeleton } from '@mui/material';
const Tenant = ({ item }) => {
    return (_jsx(ListItem, { component: 'div', title: item.Name, disableGutters: true, dense: true, children: _jsx(ListItemText, { primary: item.Name, secondary: item.Subdomain, primaryTypographyProps: { variant: 'body2', fontWeight: 500, noWrap: true } }) }));
};
const TenantSkeleton = () => {
    return (_jsxs(Box, { children: [_jsx(Skeleton, { variant: 'text', width: 150 }), _jsx(Skeleton, { variant: 'text', width: 100 })] }));
};
Tenant.propTypes = {
    item: PropTypes.shape({
        Id: PropTypes.number.isRequired,
        Name: PropTypes.string.isRequired,
        Subdomain: PropTypes.string,
    }).isRequired,
};
export default memo(Tenant);
export { TenantSkeleton };
